import type { FaireProductEntity } from "../../entity_types/product";

export const p_2chsrkwxdj: FaireProductEntity = {
  token: "p_2chsrkwxdj",
  type: "product",
  name: "Black Halter Maxi Slit Hem Dress",
  brandToken: "b_cmenfyx54t",
  brandName: "LUCKY & BLESSED",
  imageUrl:
    "https://cdn.faire.com/fastly/f5699ea31288a575a257556c9734c27d0c40ab6decd4194c193c771356ceafb1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dabdaf88626efb4c2b3511549589c9ae276c8420a2be656da3f2ea25032d78f7.jpeg",
    "https://cdn.faire.com/fastly/d132071e5df916be13c294a4b9bc44b559b1fa54c180b4c3487b4b08a5d06108.jpeg",
  ],
  priceDollars: 240,
  description:
    "Turn heads with this stunning black halter maxi dress, designed for a bold yet elegant Western-inspired look. Featuring a deep halter neckline and open back with adjustable tie closure, this piece creates a striking silhouette from every angle. The ruched waist enhances the figure while offering a flattering, contoured fit. A high side slit adds movement and a touch of edge, perfectly balancing sophistication with Western attitude. Crafted from a soft, flowy fabric, this dress drapes beautifully and is ideal for special occasions, events, or elevated everyday styling. Pair it with boots for a modern cowgirl look or dress it up for a night out.\n\nblack western dress\nhalter maxi dress\nwestern evening dress\ncowgirl formal dress\nwestern boutique clothing\nmaxi dress with slit\nwestern event outfit\nelevated cowgirl style\nblack flowy dress women\nboutique maxi dress\nnfr\nwestern\nrodeo\nwestern apparel",
  tags: [],
  msrpDollars: 480,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:42.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
